import { getLoggedUser } from '../actions/api';
import * as types from '../constants/ActionTypes';
import { STRIPE_PUBLISHABLE_KEY } from '../constants/env';
import { ghaEditInstallationLink, ghaNewInstallationLink } from '../utils/ghaLinks';
import Repository from './entities/Repository';
const getGhaRedirectLink = (ghaInstallation, user, repositoryId) => {
    if (ghaInstallation) {
        return ghaEditInstallationLink({
            installationId: ghaInstallation.installationId,
            login: ghaInstallation.login,
            type: ghaInstallation.login,
            user,
        });
    }
    return ghaNewInstallationLink(user, repositoryId);
};
export const registerWebhook = async (user, repository, dispatch, apiV2Model, isRepositoryList = false) => {
    const lastBranch = repository.branches.find((branch) => branch.main) ?? repository.branches[0];
    const repositoryEntity = new Repository(repository, lastBranch ? lastBranch.commitList : {}, lastBranch ? lastBranch.commitList?.defects : {});
    repositoryEntity.setWebhookLoading(true);
    if (isRepositoryList) {
        await dispatch({
            type: types.ADD_UPDATE_REPOSITORY,
            payload: repositoryEntity,
        });
    }
    else {
        await dispatch({
            type: types.UPDATE_REPOSITORY,
            payload: { repository: repositoryEntity },
        });
    }
    try {
        const dashboardResponse = await apiV2Model.installWebhook(repository.id);
        const repositoryWithWebhook = dashboardResponse?.repository;
        // ToDo: Can probably go in parallel with stripe request
        repositoryWithWebhook.setActive(true);
        repositoryWithWebhook.setWebhookLoading(false);
        if (isRepositoryList) {
            await dispatch({
                type: types.ADD_UPDATE_REPOSITORY,
                payload: repositoryWithWebhook,
            });
        }
        else {
            await dispatch({
                type: types.UPDATE_REPOSITORY,
                payload: { repository: repositoryWithWebhook },
            });
        }
        if (STRIPE_PUBLISHABLE_KEY && repository.private && user.user?.plan && !user.user.plan.price) {
            const loggedAction = await dispatch(getLoggedUser());
            if (loggedAction.type === types.LOGIN_USER_DETAILS_SUCCESS) {
                await dispatch({
                    type: types.LOGGED_USER,
                    payload: loggedAction.response.data,
                });
            }
        }
    }
    catch (error) {
        const ghaInstallations = user.user?.ghaInstallations || [];
        const isGhaWithoutInstallation = user.user?.gha && !ghaInstallations.length;
        const isRepositoryDisabled = !!error.graphQLErrors?.find((error) => error.message === 'Disabled repository');
        const isResourceInaccessible = !!error.graphQLErrors?.find((error) => error.message === 'Resource not accessible by integration');
        if ((isGhaWithoutInstallation && isRepositoryDisabled) || isResourceInaccessible) {
            if (ghaInstallations.length) {
                // @todo: in the future, show modal with information instead of pure redirect to GHA installation page (CF-357)
                const organizationName = repository.fullname.replace(`/${repository.name}`, '');
                // @ts-expect-error TS7031: Binding element 'login' implicitly has an 'any' type.
                const ghaInstallation = ghaInstallations.find(({ login }) => login === organizationName);
                location.href = getGhaRedirectLink(ghaInstallation, user.user, repository.id);
                return;
            }
            else {
                localStorage.removeItem('setupClosed');
                await dispatch({ type: types.FORCE_SETUP_OPEN });
            }
            repositoryEntity.setWebhookLoading(false);
            await dispatch({
                type: types.UPDATE_REPOSITORY,
                payload: { repository: repositoryEntity },
            });
        }
        else if (isRepositoryDisabled) {
            repositoryEntity.setWebhookLoading(false);
            repositoryEntity.setDisabled(true);
            if (isRepositoryList) {
                await dispatch({
                    type: types.ADD_UPDATE_REPOSITORY,
                    payload: repositoryEntity,
                });
            }
            else {
                await dispatch({
                    type: types.UPDATE_REPOSITORY,
                    payload: { repository: repositoryEntity },
                });
            }
        }
    }
};
